
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employees",
      function () {
        return require("private-next-pages/employees/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employees"])
      });
    }
  